export default __webpack_public_path__ + "static/media/partners.48979195.svg";